export default __webpack_public_path__ + "media/images/strawberry_glow-38a19f08d677bf1de785cfe14b115ec9.png";